import { createRoute, redirect } from '@tanstack/react-router';
import { rotaRaiz } from './raiz';
import { garantirSessao } from '../api';

/**
 * A lista de sessões virou a lateral do workspace.
 *
 * A rota fica de pé porque links antigos apontam para cá — e porque um painel
 * que responde 404 a um endereço que ele mesmo publicou é pior que um redireto.
 */
export const rotaSessoes = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/sessoes',
  beforeLoad: async () => {
    if (!(await garantirSessao())) throw redirect({ to: '/entrar' });
    throw redirect({ to: '/', search: { lado: 'sessoes' } });
  },
});
